module.exports = __webpack_public_path__ + "static/media/logo_uob.28241d14.svg";